// extracted by mini-css-extract-plugin
export var banner = "home-module--banner--SsSyv";
export var btn = "home-module--btn--2Jhvd";
export var text = "home-module--text--da7_l";
export var image = "home-module--image--1aSl1";
export var particles = "home-module--particles--2Z7V8";